import React from 'react';
import {setValuesAction as setVehicleConfiguratorValuesAction} from '../../_flux/actions/vehicle_configurator_actions';
import { getDefaultValueForFilter } from '../../_flux/helper/filters/get_default_value_for_filter';
import { CHECK_ORDER } from './check_order';

export function resetFiltersAfterFilter(lastFilterNotToBeResetted) {
    const lastFilterNotToBeResettedCheckOrderIndex = CHECK_ORDER.indexOf(lastFilterNotToBeResetted);

    if (lastFilterNotToBeResettedCheckOrderIndex === -1) {
        return;
    }

    const filtersToReset = CHECK_ORDER.slice(lastFilterNotToBeResettedCheckOrderIndex + 1);
    const actionPayload = filtersToReset.reduce((accumulator, currentValue) => {
        accumulator[currentValue] = getDefaultValueForFilter(currentValue);
        return accumulator;
    }, {});
    setVehicleConfiguratorValuesAction(actionPayload);
}
